import React, { useEffect, useState } from 'react';
import "./home.css";
import GameHeader from '../header/header';
import ApiService from '../../services/apiService';
import elite from '../../Assets/images/elite.png';
import amanotesLogo from '../../Assets/images/partner-1.e438616c.png';
import bandaiLogo from '../../Assets/images/partner-2.b67feceb.png';
import bkomLogo from '../../Assets/images/partner-3.1b0c8bed.png';
import blueGem from '../../Assets/images/stand.png';
import purpleGem from '../../Assets/images/mast.png';
import greenGem from '../../Assets/images/master.png';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import BGVideo from '../../../EpicGame/Assets/images/home.mp4'; // Replace with your actual path

const Home = () => {
    const [levellist, setRowData] = useState([]);
    const [itmData, setItems] = useState([]);
    const [loader, setLoader] = useState(true);
    const apiService = new ApiService();
    let navigate = useNavigate();

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            fetchuserData(items);
        }
    }, []);

    const fetchuserData = async (items) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            setItems(res?.data[0]);
            // const gameParams = new URLSearchParams();
            // gameParams.append('userId', res?.data[0]?.id);
            // gameParams.append('gameRound', res?.data[0]?.playedGames + 1);
            // const GameuseRes = await apiService.getApiParamater('GET_USER_GAME', `?${gameParams.toString()}`);
            // let rowData = GameuseRes?.data[0]
            // let userData = res?.data[0]
            // if (userData?.balance < rowData?.price) {
            //     toast?.warning('Insufficient Balance Please go to recharge')
            //     navigate(`/Recharge`, { state: { userData, rowData } });
            // }
            const GameRes = await apiService.get('GET_USER_LEVEL');
            setRowData(GameRes?.data);
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error fetching  data:", error);
        }
    };

    const mapOrderType = (memberLevel) => {
        switch (memberLevel) {
            case 1:
                return "Standard";
            case 2:
                return "Elite";
            case 3:
                return "Expert";
            case 4:
                return "Master";
            default:
                return "Standard";
        }
    };

    return (
        <div className="obtibg">
            <div className="containerbasd">
                <GameHeader />
                <div className="marquee-container mt-lg-5">
                    <div className="marquee-text">
                        Play Smart. Win Big. Work Online and Level Up Your Earnings
                    </div>
                </div>
                <div className='p-3 center'>
                    <video className="" style={{ width: "830px" }} autoPlay loop muted playsInline>
                        <source src={BGVideo} type="video/mp4" />
                    </video>
                </div>

                {/* Profile Section */}
                <div className="profile-container">
                    <div className="profile-card">
                        <div>
                            <img src={elite} alt="User Level" style={{ height: '130px' }} />
                        </div>
                        <div className="badge">{mapOrderType(itmData?.memberLevel)}</div>
                        {loader === true ?
                            "" :
                            <div className="username">{`${levellist?.find(x => x?.id === itmData?.memberLevel)?.commission?.toFixed(2)}%` || " 0 %"}</div>
                        }
                        <div className="balance-section">
                            <div className="balance-card">
                                <div className="label">Account Balance (USDC)</div>
                                <div className="value green">${itmData?.balance?.toFixed(2) || "0.00"}</div>
                            </div>
                            <div className="balance-card">
                                <div className="label">Commission (USDC)</div>
                                <div className="value green">${itmData?.winningAmount?.toFixed(2) || "0.00"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Partners Section */}
                <div className="partners-section mt-5">
                    <h2 className="text-white text-center">Our Partner</h2>
                    <div className="partners-logos d-flex justify-content-center gap-lg-5 mt-3">
                        <img src={amanotesLogo} alt="Amanotes" style={{ height: 60 }} />
                        <img src={bandaiLogo} alt="Bandai Namco" style={{ height: 60 }} />
                        <img src={bkomLogo} alt="BKOM Studios" style={{ height: 60 }} />
                    </div>
                </div>

                {/* Levels Section */}
                <div className="levels-section mt-5">
                    {levellist?.map((level) => {
                        const gemIcon = level?.name === "Standard" ? blueGem :
                            level?.name === "Expert" ? purpleGem :
                                greenGem;
                        return (
                            <div key={level?.id} className="level-card d-flex justify-content-between align-items-center p-3 mb-3" style={{ background: "#111", borderRadius: "12px" }}>
                                <div className="d-flex align-items-center">
                                    <img src={gemIcon} alt={level?.name} style={{ width: 50, marginRight: 10 }} />
                                    <div>
                                        <div className="text-white fw-bold">{level?.name}</div>
                                        <div className="text-white">{level?.commission?.toFixed(2)}%</div>
                                    </div>
                                </div>
                                <div>
                                    <a href="/UpgradeLevel" className="text-primary" >UNLOCK</a>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Home; 